import { DeviceType as DeviceEnum } from '@allesauto/utils/consts';
import { createContext, useContext } from 'react';

export interface IDeviceType {
  deviceType: DeviceEnum;
}

export const initialDeviceType = {
  deviceType: DeviceEnum.MOBILE,
};

export const DeviceType = createContext<IDeviceType>(initialDeviceType);

export const useDeviceType = (): IDeviceType => useContext(DeviceType);
